// used in environment files and replaced while deploying
var defaultApiUrl = "#{webAppGatewayApiUrl}#";